<template>
<modal-dialog
	:modal-visible="visible"
	title="Company Form"
	:submit-visible="false"
	modal-size="modal-lg"
	cancel-button-text="Done"
	v-on:closeModal="$emit('closeModal')">

	<table class="table-sm table table-striped" v-if="formRecord">
		<tbody>
			<tr>
				<th>Submitted By</th>
				<td>{{ formRecord.UpdatedBy.first_name }} {{ formRecord.UpdatedBy.last_name }}</td>
			</tr>
			<tr>
				<th>Submitted At</th>
				<td>{{ formatDateTimeToLocal(formRecord.created_at) }}</td>
			</tr>
			<tr>
				<th>Equipment</th>
				<td><router-link :to="'/equipment/edit/'+formRecord.Equipment.slug+'/log'">{{ formRecord.Equipment.description }} <div class="text-muted">({{ formRecord.Equipment.serial_num }})</div></router-link></td>
			</tr>
			<tr>
				<th>Template</th>
				<td>{{ formRecord.FormChildTemplate.FormTemplate.title }}</td>
			</tr>
			<tr>
				<th>Child Template</th>
				<td>{{ formRecord.FormChildTemplate.description }}</td>
			</tr>
			<tr>
				<th>Project/Service</th>
				<td v-if="formRecord.Job">
					<router-link :to="'/project/'+formRecord.Job.slug+'/dashboard'">Project #{{ formRecord.Job.job_num }}</router-link>
				</td>
				<td v-if="formRecord.Service">
					<router-link :to="'/service/'+formRecord.Job.slug+'/dashboard'">Service #{{ formRecord.Service.job_num }}</router-link>
				</td>
			</tr>
		</tbody>
	</table>

	<div class="bg-light p-2">
		<form-static-render
			:form="form"
			:participants-prop="participants">
		</form-static-render>
	</div>

</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import FormStaticRender from "@/components/company_forms/FormStaticRender"

export default {
	name: "EquipmentFormViewModal",
	components: {
		ModalDialog,
		FormStaticRender
	},
	props: [
		"formRecord",
		"visible"
	],
	computed: {
		participants() {
			if (!this.formRecord)
				return []
			if ("CompanyFormAcknowledgement" in this.formRecord && this.formRecord.CompanyFormAcknowledgement)
				return this.formRecord.CompanyFormAcknowledgement
			else
				return []
		},
		form() {
			let form = {}
			try {
				form = JSON.parse(this.formRecord.form_json)
			}
			catch (e) {}
			
			return form
		}
	}
}

</script>